// extracted by mini-css-extract-plugin
module.exports = {"auditDetailCard":"AuditDetailCard_auditDetailCard__3CEjZ","centered":"AuditDetailCard_centered__2zzQr"};